"use client";

import { useState } from "react";
import IconArrowDown from "@/app/(components)/generics/Icons/IconArrowDown";
import { useT } from "@/app/translations/useT";

import { DefaultProps } from "@/app/types/common/DefaultProps";
import { FAQKeys } from "@/app/types/common/FAQKeys";
import { Emails } from "@/app/vars/Emails";
import homeStyles from "../../Home.module.css";
import { frenchSpacing } from "./FAQ.logic";
import styles from "./FAQ.module.css";

type Props = DefaultProps & {
  keys: FAQKeys;
};

export default function FAQ(props: Props) {
  const T = useT();
  const { keys } = props;

  const [activeIndex, setActiveIndex] = useState<null | number>(null);

  const toggleAccordion = (index: number) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  const formatHowMoreText = (text: string) => {
    const emailLink = (
      <a href={`mailto:${Emails.CONTACT}`} target="_blank" rel="noopener">
        {Emails.CONTACT}
      </a>
    );

    const parts = text.split(/(Discord|contact@meidly.com)/g);

    return (
      <>
        {parts.map((part, index) => {
          if (part === "contact@meidly.com") {
            return <span key={`faq-part-${index}`}>{emailLink}</span>;
          }

          return frenchSpacing(part);
        })}
      </>
    );
  };

  const renderItem = (faq: FAQKeys["items"][number], index: number) => {
    const isOpen = activeIndex === index;
    return (
      <div key={`faq-${index}`} className={`${styles.faq} ${isOpen ? styles.faqOpen : ""}`}>
        <button
          type="button"
          className={styles.faqHeader}
          onClick={() => toggleAccordion(index)}
          aria-expanded={isOpen}
        >
          <h3 className={styles.faqTitle}>{frenchSpacing(T(faq.titleKey))}</h3>
          <span className={styles.faqChevron}>
            <IconArrowDown size={22} />
          </span>
        </button>
        <div className={styles.faqAnswer}>
          <div className={styles.faqAnswerInner}>
            {faq.descriptionKeys.map((descKey, j) => (
              <p key={`faq-description-${index}-${j}`} className={styles.faqText}>
                {formatHowMoreText(T(descKey))}
              </p>
            ))}
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.container}>
      <div className={homeStyles.titles}>
        <h3 className={homeStyles.supTitle}>{T(keys.supTitle)}</h3>
        <h2 className={homeStyles.title}>{T(keys.title)}</h2>
      </div>

      <div className={styles.faqs}>{keys.items.map((faq, index) => renderItem(faq, index))}</div>
    </div>
  );
}
